import { render, staticRenderFns } from "./DeleteSubFolderConfigDialog.vue?vue&type=template&id=aa72fb5e&scoped=true&"
import script from "./DeleteSubFolderConfigDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSubFolderConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSubFolderConfigDialog.vue?vue&type=style&index=0&id=aa72fb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa72fb5e",
  null
  
)

export default component.exports